export default __webpack_public_path__ + "media/images/10-c2771208da5c63f719a20ad13531d6c4.jpg";